export default "__VITE_ASSET__CzxDKh1a__"